<template>
    <div>
        <Field label="现场照片" required>
            <UploadImage slot="input"
                         :imageList="image"
                         type="SafetyImage"
                         :count="1"
                         @imageChange="imageChange"
                         edit
            />
        </Field>
        <Field
                clearable
                label="打卡点"
                placeholder="请输入名称"
                v-model="point.name"
                required
                :rules="[{ required: true, message: '请输入名称' }]"
        />
        <Field
                clearable
                label="所属单位"
                placeholder="请选择所属单位"
                v-model="point.unitName"
                right-icon="arrow-down"
                required
                disabled
                @click="!pointId?unitPanel=true:''"
                :rules="[{ required: true, message: '所属单位必填' }]"
        />
        <Field label="启用状态" required>
            <ASwitch slot="button" v-model="point.open" size="24"/>
            <div slot="input"/>
        </Field>
        <Field
                clearable
                label="详细地址"
                v-model="point.address"
                required
                right-icon="location"
                @click-right-icon="switchPanel('map')"
        />
        <Field label="每日模板" @click="dayTemplatePanel=true"
               right-icon="arrow-down">
            <div slot="input" style="display: flex;flex-wrap: wrap">
                <div class="template-item" v-for="item in point.dayTemplateList" :key="item.id">{{item.name}}</div>
            </div>
        </Field>
        <Field label="每周模板" @click="weekTemplatePanel=true"
               right-icon="arrow-down">
            <div slot="input" style="display: flex;flex-wrap: wrap">
                <div class="template-item" v-for="item in point.weekTemplateList" :key="item.id">{{item.name}}</div>
            </div>
        </Field>
        <Field label="每月模板" @click="monthTemplatePanel=true"
               right-icon="arrow-down">
            <div slot="input" style="display: flex;flex-wrap: wrap">
                <div class="template-item" v-for="item in point.monthTemplateList" :key="item.id">{{item.name}}</div>
            </div>
        </Field>
        <Field
                clearable
                label="备注"
                placeholder="请输入备注"
                v-model="point.remark"
        />

        <div v-if="pointId == null">
            <pf code="SAFETY_POSITION_ADD">
                <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确认保存</Button>
            </pf>
        </div>
        <div v-else>
            <pf code="SAFETY_POSITION_EDIT">
                <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确认保存</Button>
            </pf>
        </div>
        <SelectTreePopup :show="unitPanel" :defaultSelected="point.unitId?{id:point.unitId,name:point.unitName}:{}"
                         :treeData="unitList"
                         :defaultTitle="point.unitName" @ok="onUnitOk" @cancel="unitPanel=false"/>
        <MapPanel :show="mapPanel" @panel="switchPanel"
                  :areaId="point.areaId" :lng="point.lng" :lat="point.lat" type="map"
        />
        <SelectSafetyTemplatePopup :templates="templates" :show="dayTemplatePanel"
                                   :defaultSelected="point.dayTemplateList"
                                   @cancel="dayTemplatePanel = false" @ok="daySelectTemplate"/>
        <SelectSafetyTemplatePopup :templates="templates" :show="weekTemplatePanel"
                                   :defaultSelected="point.weekTemplateList" :templateIdList="point.weekTemplateIdList"
                                   @cancel="weekTemplatePanel = false" @ok="weekSelectTemplate"/>
        <SelectSafetyTemplatePopup :templates="templates" :show="monthTemplatePanel"
                                   :defaultSelected="point.monthTemplateList"
                                   @cancel="monthTemplatePanel = false" @ok="monthSelectTemplate"/>
    </div>
</template>

<script>
    import {Button, Cell, Field, Form, NavBar, Switch} from "vant"
    import UploadImage from "@/components/UploadImage";
    import MapPanel from "@/components/MapPanelreport";
    import {mapGetters} from 'vuex'
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectSafetyTemplatePopup from "@/components/SelectPopup/SelectSafetyTemplatePopup";

    export default {
        components: {
            SelectTreePopup, MapPanel, ASwitch: Switch,
            Cell, UploadImage,
            Form, Field, Button, NavBar,
            SelectSafetyTemplatePopup
        },
        props: {},
        data() {
            return {
                pointId: this.$route.params.id,
                unitPanel: false,
                mapPanel: false,
                // templatePanel: false,
                dayTemplatePanel: false,
                weekTemplatePanel: false,
                monthTemplatePanel: false,
                point: {
                    image: '',
                    open: true,
                    unitId: '',
                    unitName: '',
                    // templateList: []，
                    dayTemplateList: [],
                    weekTemplateList: [],
                    monthTemplateList: [],
                    dayTemplateIdList: [],
                    weekTemplateIdList: [],
                    monthTemplateIdList: []
                },
                templates: []
            }
        },
        computed: {
            image() {
                return this.point.image ? [this.point.image] : [];
            },
            ...mapGetters({unitList: 'global/unitList'}),
        },
        created() {
            if (this.pointId == null) {
                this.$initUnit(this.point, {
                    'unitId': 'id',
                    'unitName': 'name',
                    'areaId': 'areaId',
                    'lng': 'lng',
                    'lat': 'lat'
                })
            }
        },
        mounted() {
            if (this.pointId) {
                this.getPointDetail()
            }
            this.getTemplateList()
        },
        methods: {
            getPointDetail() {
                this.$http.tokiot.safety.position.get({id: this.pointId})
                    .then(res => {
                        if (res) {
                            this.point = res
                            this.point.dayTemplateIdList = res.dayTemplateList.map((item) => item.id)
                            this.point.weekTemplateIdList = res.weekTemplateList.map((item) => item.id)
                            this.point.monthTemplateIdList = res.monthTemplateList.map((item) => item.id)
                        }
                    })
            },
            onChangeUnit(unitId,) {
                if (!this.pointId) {
                    this.point.templateList = []
                }
                this.getTemplateList(unitId)
            },
            getTemplateList(unitId = '') {
                this.$http.tokiot.safety.template.list({
                    size: 999,
                    currentUnit: true,
                    superUnit: true,
                    unitId
                })
                    .then(res => {
                        if (res) {
                            this.templates = res.rows
                        }
                    })
            },
            onUnitOk(data) {
                this.unitPanel = false
                this.point.unitId = data.id;
                this.point.unitName = data.name;
                this.point.areaId = data.areaId;
                this.point.lng = data.lng;
                this.point.lat = data.lat;
            },
            submit() {
                this.$toast.loading("正在处理中...")
                if (this.pointId == null) {
                    this.$http.tokiot.safety.position.create(this.point)
                        .then(res => {
                            if (res) {
                                this.$toast.success("添加成功")
                                setTimeout(() => this.$router.go(-1), 500)
                            } else {
                                this.$toast.fail(res.message)
                            }
                        })
                } else {
                    this.$http.tokiot.safety.position.update(this.point)
                        .then(res => {
                                if (res) {
                                    this.$toast.success("修改成功")
                                    setTimeout(() => this.$router.go(-1), 500)
                                } else {
                                    this.$toast.fail(res.message)
                                }
                            }
                        )
                }
            },
            switchPanel(type, data) {
                switch (type) {
                    case "map":
                        if (data && data !== "map") {
                            if (data[0] !== 0 && data[1] !== 0) {
                                let This = this;
                                new AMap.Geocoder().getAddress(data, function (status, result) {
                                    This.$set(This.point, "address", result.regeocode.formattedAddress)
                                });
                                This.$set(This.point, "lng", data[0])
                                This.$set(This.point, "lat", data[1])
                            }
                        }
                        console.info('地图', data, this.point)
                        this.mapPanel = !this.mapPanel;
                        break;
                    default:
                        break;
                }
            },
            imageChange(imageList) {
                this.point.image = imageList[0];
            },
            daySelectTemplate(templates) {
                this.point.dayTemplateIdList = templates.map((item) => item.id)
                this.point.dayTemplateList = templates;

                this.dayTemplatePanel = false;
            },
            weekSelectTemplate(templates) {
                this.point.weekTemplateIdList = templates.map((item) => item.id)
                this.point.weekTemplateList = templates;
                this.weekTemplatePanel = false;
            },
            monthSelectTemplate(templates) {
                this.point.monthTemplateIdList = templates.map((item) => item.id)
                this.point.monthTemplateList = templates;
                this.monthTemplatePanel = false;
            },
        },
        watch: {
            'point.lng'(lng) {
                console.info('lng', lng)
            },
            'point.lat'(lat) {
                console.info('lat', lat)
            },
            'point.unitId'(unitId) {
                this.onChangeUnit(unitId)
            },
            'point.address'(address) {
                console.info('address', address)
            },
        }
    }
</script>

<style lang="less" scoped>
    .template-item {
        background: #07c160;
        padding: 2px 8px;
        margin-right: 5px;
        color: #fff;
        margin-bottom: 2px;
        border-radius: 3px;
    }
</style>